import React, { PureComponent } from 'react';
import styles from './index.css';
import { h5PageCount, callUpVideoApp } from '../../../utils';
/**
 * 拉起视频客户端
 */
// @flow
class CallUpVideoAppHead extends PureComponent {
    constructor(props) {
        super(props);
        this.stickyTop = () => {
            this.setState({
                stickyTop: true,
            });
        };
        this.removeStickTop = () => {
            this.setState({
                stickyTop: false,
            });
        };
        this.handleClick = () => {
            const { clickCount } = this.props;
            if (clickCount) {
                h5PageCount([clickCount]);
            }
            callUpVideoApp({
                apiUrl: '//api.iclient.ifeng.com/wakeupiOS/video/ifengplayer?type=liveroom&id=100008&kind=sf',
                protocolUrl: 'ifengVideoPlayer',
                downloadUrl: '//api.3g.ifeng.com/ifengvideo_tg12',
            });
        };
        const src = (this.props.content && this.props.content.src) ||
            '//p0.ifengimg.com/fe/video_client/images/logo@3x_88587755.png';
        const stickyTop = this.props.stickyTop || false;
        this.state = {
            stickyTop,
            src,
        };
    }
    render() {
        const { src, stickyTop } = this.state;
        return (React.createElement("header", { ref: "header", className: `${styles.header} ${stickyTop ? styles.stickyTop : ''}`, id: "callVideoAppHeader" },
            React.createElement("a", { href: "javascript:;", className: styles.headerBox, onClick: this.handleClick },
                React.createElement("span", { className: styles.logo },
                    React.createElement("img", { src: src })),
                React.createElement("span", { className: styles.botton }, "\u7ACB\u5373\u6253\u5F00"))));
    }
}
export default CallUpVideoAppHead;
